<nav class="hc-breadcrumb">
  <button type="button" class="hc-link" (click)="back.emit()">All Collections</button>
  <span class="hc-breadcrumb-sep">›</span>
  <span>{{ collection }}</span>
</nav>

@if (loading) {
  <div class="hc-loading">
    <mat-progress-spinner mode="indeterminate" diameter="36"></mat-progress-spinner>
  </div>
}

@if (error) {
  <p class="hc-error">Sorry, we couldn't load this collection right now. Please try again later.</p>
}

@if (!loading && !error) {
  <header class="hc-collection-head">
    <span class="hc-card-icon"><mat-icon>{{ icon }}</mat-icon></span>
    <div class="hc-collection-head-text">
      <h1>{{ collection }}</h1>
      <p class="hc-collection-meta">{{ total }} {{ total === 1 ? 'article' : 'articles' }}</p>
    </div>
  </header>

  @if (total === 0) {
    <p>No articles in this collection yet.</p>
  }

  @if (standalone.length > 0) {
    <div class="hc-list-card">
      @for (article of standalone; track article.slug) {
        <button type="button" class="hc-row" (click)="openArticle.emit(article.slug)">
          <span class="hc-row-title">{{ article.title }}</span>
          <mat-icon>chevron_right</mat-icon>
        </button>
      }
    </div>
  }

  @for (section of sections; track section.category) {
    <div class="hc-list-card">
      <h2 class="hc-list-card-title">{{ section.category }}</h2>
      @for (article of section.articles; track article.slug) {
        <button type="button" class="hc-row" (click)="openArticle.emit(article.slug)">
          <span class="hc-row-title">{{ article.title }}</span>
          <mat-icon>chevron_right</mat-icon>
        </button>
      }
    </div>
  }
}
